export default {
	title: 'timer',
	components: [{ title: 'auto', component: 'auto_diffuser_gen_2' }],
};
